<section class="corte-lista" aria-labelledby="corte-lista-titulo">
  <div class="corte-lista-header">
    <h3 id="corte-lista-titulo" class="corte-lista-titulo">Cortes adicionados</h3>
    <span class="corte-lista-count">{{ itens.length }} {{ itens.length === 1 ? "item" : "itens" }}</span>
  </div>

  <div *ngIf="linhasGrid.length === 0" class="corte-lista-vazia">
    <p class="mb-0">
      Nenhum corte adicionado ainda. Use o formulário acima para começar.
    </p>
  </div>

  <div *ngIf="linhasGrid.length > 0" class="table-responsive corte-table-wrap">
    <table class="table table-sm mb-0 corte-table">
      <thead>
        <tr>
          <th *ngIf="exibirColunasBarra">Barra</th>
          <th>Corte</th>
          <th>Tamanho</th>
          <th class="text-right">Total</th>
          <th *ngIf="exibirColunasBarra" class="text-right">Sobra</th>
          <th class="text-right">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let lin of linhasGrid; trackBy: trackLinhaGrid"
          [class.corte-row-edicao]="editandoId != null && editandoId === (encontrarItemId(lin) || '')"
          [class.corte-row-flash]="lin.flash"
          [class.corte-row-fim-barra]="lin.fimGrupoBarra"
        >
          <td
            *ngIf="exibirColunasBarra"
            class="align-middle font-weight-medium corte-celula-barra"
          >
            {{ lin.barra }}
          </td>
          <td class="align-middle font-weight-medium">{{ lin.qtd }}</td>
          <td class="align-middle">{{ fmt(lin.comprimento_util) }} m</td>
          <td class="align-middle text-right">{{ fmt(totalLinha(lin)) }} m</td>
          <td *ngIf="exibirColunasBarra" class="align-middle text-right corte-celula-sobra">
            <ng-container *ngIf="lin.sobra != null; else sobraVazia">
              {{ fmt(lin.sobra) }} m
            </ng-container>
            <ng-template #sobraVazia>—</ng-template>
          </td>
          <td class="align-middle text-right">
            <button
              type="button"
              class="btn btn-sm btn-outline-warning mr-1"
              [disabled]="bloqueado || !podeAcionarLinha(lin)"
              (click)="onEditarLinha(lin, $event)"
              title="Editar"
            >
              Editar
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              [disabled]="bloqueado || !podeAcionarLinha(lin)"
              (click)="onExcluirLinha(lin, $event)"
              title="Excluir"
            >
              Excluir
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<section class="resumo-container">
  
  <!-- TÍTULO FORA -->
  <h3 class="resumo-titulo">Resumo do pedido</h3>

  <div class="resumo-stack">
    <div class="resumo-grid">
      <div class="resumo-card">
        <div class="resumo-linha">
          <span>Quantidade total de cortes</span>
          <strong>{{ resumo.totalCortes }}</strong>
        </div>

        <div class="resumo-linha">
          <span>Total solicitado</span>
          <strong>{{ fmt(resumo.totalSolicitado) }} m</strong>
        </div>

        <div class="resumo-linha destaque">
          <span>Sobras</span>
          <strong>{{ fmt(resumo.sobraTotal) }} m</strong>
        </div>

        <div
          class="resumo-linha"
          *ngIf="resumo.sobraLiquida != null && resumo.sobraLiquida !== resumo.sobraTotal"
        >
          <span>Sobra líquida</span>
          <strong>{{ fmt(resumo.sobraLiquida) }} m</strong>
        </div>

        <div class="resumo-linha">
          <span>Total ajustado (com sobra)</span>
          <strong>{{ fmt(resumo.totalFinal) }} m</strong>
        </div>

        <div class="resumo-linha">
          <span>Fator de conversão</span>
          <strong>{{ fmtFator(fatorConversaoNumero) }}</strong>
        </div>
      </div>

      <div class="resumo-card">
        <div class="resumo-linha">
          <span>Estoque (MT)</span>
          <strong>{{ fmt(estoqueMt) }} mt</strong>
        </div>

        <div class="resumo-linha">
          <span>Estoque (Kg)</span>
          <strong>{{ fmt(estoqueKg) }} kg</strong>
        </div>

        <div class="resumo-linha destaque">
          <span>Peso</span>
          <strong>{{ fmtPeso(pesoExibido) }} kg</strong>
        </div>

        <div class="resumo-linha">
          <span>Preço Unitário</span>
          <strong>R$ {{ precoUnitarioExibido | currency:'BRL':'' }}</strong>
        </div>

        <div class="resumo-linha total">
          <span>Valor Total</span>
          <strong>R$ {{ valorTotal | currency:'BRL':'' }}</strong>
        </div>
      </div>
    </div>

    <div class="devolucao-grid" *ngIf="exibirControleDevolucoes">
      <app-corte-devolucao-controle
        [dados]="dadosDevolucao"
        [fatorConversao]="fatorConversaoNumero"
        [precoUnitario]="precoUnitarioExibido"
        [corteBloco]="corteBloco"
        [bloqueado]="bloqueado"
        (acao)="onDevolucaoAcao($event)"
      ></app-corte-devolucao-controle>
    </div>
  </div>
  <div *ngIf="mostrarAvisoSobra" class="resumo-aviso">
    Este produto não permite fracionamento. Será considerado 1 barra adicional.
  </div>
</section>